import styled from 'styled-components'
import { BREAKPOINT_SM } from '../../theme/ota'

export type ContainerProps = {

}

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  padding: 0px;

  @media (max-width: calc(${BREAKPOINT_SM})) {
    border-bottom: none;
    padding-bottom: 0;
  }
`

export const TitleContainer = styled.div`
  align-items: center;
  display: flex;
  margin: 0 0 20px;
`

export const Title = styled.h4`
  color: ${({ theme }) => theme?.colors?.text};
  font: normal normal bold 14px/23px Manrope, sans-serif;
  letter-spacing: 0px;
  margin: 0;
  text-align: left;
`

export const TitleInfo = styled.span`
  color: ${({ theme }) => theme?.colors?.text};
  font: normal normal normal 12px/21px Manrope, sans-serif;
  letter-spacing: 0px;
  margin: 0 0 0 5px;
  text-align: left;
`
